import { addSideEffects } from '@poa/state';
import {
  fetchCredList,
  refreshAccounts,
  fetchUsers,
  fetchMsgs,
  saveChatJson ,
  fetchUserCredList
} from './chats.actions';


// fetch
addSideEffects(fetchCredList, async (payload, { actions, env, store }) => {
  try {
    const response = await env.api.chats.fetchCredList()
    actions.chatsActions.fetchCredListSuccess(response);
  } catch (e) {
    console.error(e);
    actions.chatsActions.fetchCredListFailed(e);
  }
});


addSideEffects(fetchUserCredList, async (payload, { actions, env, store }) => {
  try {
    const response = await env.api.chats.fetchUserCredList()
    actions.chatsActions.fetchCredListSuccess(response);
  } catch (e) {
    console.error(e);
    actions.chatsActions.fetchCredListFailed(e);
  }
});


async function fetchAccountsFilterRequest(env, {
  filter_by = null,
  page = 1,
  sort_by = null,
  search = null,
  page_size = 200,
  status = null
}) {
  return env.api.chats.fetchAccountsFilter(filter_by, page, sort_by, search, page_size, status);
}


addSideEffects(
  refreshAccounts,
  async ({
    filter_by,
    page,
    search,
    page_size,
    status
  }, { actions, env }) => {
    try {
      const accounts = await fetchAccountsFilterRequest(env, {
        filter_by: filter_by,
        page: page,
        sort_by: {},
        search: search,
        page_size: page_size,
        status: status
      });

      actions.chatsActions.fetchAccountsSuccess(accounts);
    } catch (e) {
      console.error(e);
      actions.chatsActions.fetchAccountsFailed();
    }
  });


addSideEffects(
  fetchUsers,
  async ({ account_id, cred_id }, { actions, env }) => {
    try {
      const users = await env.api.chats.fetchUsers(account_id, cred_id);
      actions.chatsActions.fetchUsersSuccess(users);
    } catch (e) {
      console.error(e);
      actions.chatsActions.fetchUsersFailed();
    }
  });


addSideEffects(
  saveChatJson,
  async ({ chat_data }, { env }) => {
    try {
      const data = await env.api.chats.saveChatJson(chat_data).then((response) => {
        return response.data;
      }
      );
      if (!data || !data.status === 'ok') {
        throw new Error('Не удалось сохранить данные');
      }
      env.alert('Успех', `Данные успешно сохранены`);
    } catch (e) {
        console.error(e);
        env.alert(
          'Ошибка',
          `Ошибка. Данные не сохранены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
        );
    }
  });


addSideEffects(
  fetchMsgs,
  async ({ account_id, cred_id, user_id }, { actions, env }) => {
    try {
      const msgs = await env.api.chats.fetchMsgs(account_id, cred_id, user_id);
      actions.chatsActions.fetchMsgsSuccess(msgs);
    } catch (e) {
      console.error(e);
      actions.chatsActions.fetchMsgsFailed();
    }
  });
